var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon",style:({fontSize: `${_vm.font}px`}),attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":`#${_vm.type}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }